import { render, staticRenderFns } from "./ListImplementasiMpp.vue?vue&type=template&id=2241573a&scoped=true&"
import script from "./ListImplementasiMpp.vue?vue&type=script&lang=ts&"
export * from "./ListImplementasiMpp.vue?vue&type=script&lang=ts&"
import style0 from "./ListImplementasiMpp.vue?vue&type=style&index=0&id=2241573a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241573a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
